import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { responsiveFontSizes, ThemeProvider } from '@mui/material/styles'
import { theme } from './theme/Theme'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
);
